import React from 'react'

import './FooterDisclaimer.component.scss'

const FooterDisclaimer = () => {
  return (
    <div className='footer-disclaimer'>
      <p className='footer-disclaimer__text'>
        <span>
          We do not offer every plan available in your area. We currently represent 88 organizations. Any information we
          provide is limited to those plans we do offer in your area. Please contact&nbsp;
        </span>
        <a href='http://medicare.gov/' target='_blank' rel='noopener noreferrer'>
          medicare.gov
        </a>
        <span>
          , 1-800-MEDICARE, or your local State Health Insurance Program (SHIP) to get information on all of your
          options. Not connected with or endorsed by the United States Government or the Federal Medicare Program. This
          is solicitation for insurance.
        </span>
      </p>
    </div>
  )
}

export default FooterDisclaimer
